import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import ThemeToggel from "../../Component/ThemeToggel"
import logo from "../../Image/D.jpg"
import logo2 from "../../Image/DK _white.jpg"
const Navbar = () => {
  let navigate = useNavigate();
  const [nav, setNav] = useState(false);
  const handleNav = () => {
    setNav(!nav);
  };
  const pageLoading = (e, data) => {
    if (data === "about") {
      navigate("/Intermetent");
      setTimeout(() => {
        navigate("/about");
      }, 3000);
    }
    if (data === "myskill") {
      navigate("/Intermetent");
      setTimeout(() => {
        navigate("/mySkill");
      }, 3000);
    }
    if (data === "contact") {
      navigate("/Intermetent")
      setTimeout(() => {
        navigate("/Contact");
      }, 3000);
      
    }
    if (data === "blog") {
      navigate("/Intermetent")
      setTimeout(() => {
        navigate("/Sorry");
      }, 3000);
    }

    if (data === "exp") {
      navigate("/Intermetent");
      setTimeout(() => {
        navigate("/Experience");
      }, 3000);
    }
  };
  return (
    <div className="flex justify-between items-center h-24 w-full mx-auto md:px-4 dark:text-white">
      <div className=" flex flex-row "

      >
      
        <img src={logo} alt="" className="hidden dark:block" />
        <img src={logo2} alt="" className=" block dark:hidden" />
       <div className=" mt-[24px]">
       <ThemeToggel />
       </div>
       
      </div>
      <ul className="hidden md:flex ">
        <li
          className="p-4 cursor-pointer hover"
          onClick={(e) => pageLoading(e, "about")}
        >
          About
        </li>

        <li
          className="p-4 cursor-pointer hover"
          onClick={(e) => pageLoading(e, "myskill")}
        >
          MySkill
        </li>

        <li
          className="p-4 cursor-pointer hover"
          onClick={(e) => pageLoading(e, "contact")}
        >
          Contact
        </li>

        <li
          className="p-4 cursor-pointer hover"
          onClick={(e) => pageLoading(e, "blog")}
        >
          Blog
        </li>

        <li
          className="p-4 cursor-pointer hover"
          onClick={(e) => pageLoading(e, "exp")}
        >
        Experience
        </li>
      </ul>
      <div onClick={handleNav} className="block  cursor-pointer md:hidden">
        {nav ? <AiOutlineClose size={30} /> : <AiOutlineMenu size={30} />}
      </div>
      <ul
        className={
          nav
            ? "fixed left-0 top-0 w-[60%] h-full border-r border-r-gray-900 bg-[#FFFFFF] dark:bg-[#252525] ease-in-out duration-500"
            : "ease-in-out duration-500 fixed left-[-100%]"
        }
      >
        <h1 className="w-full  text-2xl md:text-3xl px-2 font-bold dark:text-[#252525] GFG  ">
          DEEPESH KUMAR

        </h1>

        <li className="p-4 border-b border-gray-600 cursor-pointer mobile" onClick={(e) => pageLoading(e, "about")}>About</li>

        <li className="p-4 border-b border-gray-600 cursor-pointer mobile" onClick={(e) => pageLoading(e, "myskill")}>
          My Skill
        </li>

        <li className="p-4 border-b border-gray-600 cursor-pointer mobile" onClick={(e) => pageLoading(e, "contact")}>Contact</li>

        <li className="p-4 border-b border-gray-600 cursor-pointer mobile" onClick={(e) => pageLoading(e, "blog")}>Blog</li>
        <li className="p-4 border-gray-600 cursor-pointer mobile" onClick={(e) => pageLoading(e, "exp")}>Experience</li>
      </ul>
    </div>
  );
};

export default Navbar;
